import type { PainPoint } from '../types/content'

export const painPoints: PainPoint[] = [
  {
    problem: 'Hours spent figuring out what to teach next',
    impact: 'Time spent searching instead of coaching.',
  },
  {
    problem: 'Practices that feel repetitive',
    impact: 'Athletes disengage and progress slows down.',
  },
  {
    problem: "Random drills that don't connect into a progression",
    impact: 'Skills never build on each other from week to week.',
  },
  {
    problem: 'Athletes learning techniques but struggling to apply them live',
    impact: 'Technique stays in drilling and never shows up in matches.',
  },
  {
    problem: 'Too much unstructured live wrestling',
    impact: 'Fatigue without a clear coaching objective.',
  },
  {
    problem: 'Difficulty adapting sessions for different levels',
    impact: 'Beginners get lost while advanced athletes stay unchallenged.',
  },
  {
    problem: 'The same match mistakes appearing again and again',
    impact: 'No system to identify and correct recurring patterns.',
  },
  {
    problem: 'Last-minute tournament preparation',
    impact: 'Athletes arrive at competition under-prepared.',
  },
  {
    problem: 'Conditioning that creates fatigue without improving wrestling',
    impact: 'Hard work that never transfers to the mat.',
  },
  {
    problem: 'No clear way to decide what each athlete should work on next',
    impact: 'Individual development is left to guesswork.',
  },
]
